import React from "react";
import "./HomePage.css";
import HomePageHeader from "../HomePageHeader";
import ArrowUpwardIcon from '@material-ui/icons/ArrowUpward';

//Page components
import Home from "../Pages/Home";
import Cities from "../Pages/Cities";
import Gallery from "../Pages/Gallery";
import News from "../Pages/News";
import About from "../Pages/About";

import { BrowserRouter as Router, Switch, Route } from "react-router-dom";

function index() {
  function  Slider (){
    document.body.scrollTop = 0;
    document.documentElement.scrollTop = 0;
  }
  return (
    <Router>
      <div className="homepage">
        <HomePageHeader />
        <Switch>
          <Route exact path="/homepage">
            <Home />
          </Route>
          <Route path="/homepage/cities">
            <Cities />
          </Route>
          <Route path="/homepage/gallery">
            <Gallery />
          </Route>
          <Route path="/homepage/news">
            <News />
          </Route>
          <Route path="/homepage/about">
            <About />
          </Route>
        </Switch>
          <button className="top-slider" onClick={()=>Slider()}>
            <ArrowUpwardIcon/>
          </button>
      </div>
    </Router>
  );
}

export default index;
